var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define('charts/timechart',["require", "exports", "../tracks/track-state", "../tracks/track-store", "../tracks/trimmer", "../util/convert", "./basechart", "./dataseries", "./layers/flares", "./layers/flightmodes", "./layers/markers", "./layers/series", "./layers/timefocus", "./layers/trim"], function (require, exports, trackState, trackStore, trimmer_1, convert_1, basechart_1, dataseries, flares_1, flightmodes_1, markers_1, series_1, timefocus_1, trim_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.init = exports.TimeChart = void 0;
    var margin = {
        bottom: 35,
        top: 5,
        right: 88,
        left: 50
    };
    var TimeChart = /** @class */ (function (_super) {
        __extends(TimeChart, _super);
        /** Load track data, and initialize chart */
        function TimeChart(elementSelector, series) {
            var _this = _super.call(this, elementSelector, margin, 4) || this;
            _this.track = undefined;
            _this.focusLayer = new timefocus_1.TimeFocus();
            _this.trimLayer = undefined;
            // Represents the current track trim
            _this.trimmer = undefined;
            _this.bisectDate = d3.bisector(function (d) { return d.date; }).left;
            _this.zoom = d3.zoom();
            _this.series = series;
            if (!document.querySelector(elementSelector))
                return _this;
            // Default domain of the data
            _this.xAxis.scale = d3.scaleTime();
            _this.xAxis.scale.domain([0, 4000]);
            _this.yAxis[0].scale.domain([0, 1000]);
            _this.yAxis[1].scale.domain([0, 100]);
            _this.yAxis[2].scale.domain([0, 4]);
            _this.yAxis[3].scale.domain([-180, 180]);
            // Copy the original x scale so that we can zoom it
            _this.xScale0 = _this.xAxis.scale.copy();
            // Setup axes
            _this.xAxis.ticks = 5;
            _this.xAxis.axis = d3.axisBottom(_this.xAxis.scale);
            _this.yAxis[0].ticks = 5;
            _this.yAxis[0].axis
                .tickFormat(function (d) { return Math.floor(d) + convert_1.default.distance.label; });
            _this.yAxis[1].ticks = 5;
            _this.yAxis[1].axis = d3.axisRight(_this.yAxis[1].scale)
                .tickFormat(function (d) { return Math.floor(d) + convert_1.default.speed.label; });
            _this.yAxis[2].ticks = 4;
            _this.yAxis[2].axis = d3.axisRight(_this.yAxis[2].scale)
                .tickFormat(function (d) { return Math.floor(d) + ":1"; });
            _this.yAxis[3].ticks = 5;
            _this.yAxis[3].axis = d3.axisRight(_this.yAxis[3].scale)
                .tickFormat(function (d) { return Math.floor(d) + "°"; });
            // Clipping path
            _this.clipping = _this.svg.append("defs")
                .append("clipPath")
                .attr("id", "chart-clipping-time")
                .append("rect")
                .attr("height", _this.fullHeight());
            // Add ChartLayers
            _this.addLayer(_this.focusLayer);
            // Handle zoom
            _this.zoom
                .scaleExtent([1, 1000])
                .on("zoom", function (event) {
                _this.xAxis.scale.domain(event.transform.rescaleX(_this.xScale0).domain());
                _this.update();
            });
            // Listen for x-zoom
            _this.zoomOverlay = _this.layers.svgg.append("rect")
                .attr("class", "overlay zoom")
                .attr("height", margin.bottom)
                .style("fill", "none")
                .call(_this.zoom);
            // Listen for hot keys
            dataseries.seriesUpdates.subscribe(function () { return _this.update(); });
            // On window resize, re-draw the chart
            window.addEventListener("resize", function () { return _this.update(); });
            // Initial chart update
            _this.update();
            return _this;
        }
        /**
         * Update chart data
         */
        TimeChart.prototype.update = function () {
            if (this.svg === undefined)
                return console.error("Should not update without chart");
            // Update bounds
            var width = this.width();
            var height = this.height();
            // Update clipping
            this.clipping
                .attr("width", width);
            // Move the axes
            this.xAxis.layer
                .attr("transform", "translate(0," + height + ")");
            this.yAxis[1].layer
                .attr("transform", "translate(" + (width + 30) + ",0)");
            this.yAxis[2].layer
                .attr("transform", "translate(" + width + ",0)");
            this.yAxis[3].layer
                .style("display", "none");
            // Update zoom
            this.xScale0.range([0, width]);
            this.zoom
                .extent([[0, 0], [width, height]])
                .translateExtent([[0, 0], [width, height]]);
            this.zoomOverlay
                .attr("width", width)
                .attr("transform", "translate(0," + height + ")");
            // Do the chart update AFTER we've updated the axes
            _super.prototype.update.call(this);
        };
        TimeChart.prototype.loadTrack = function (track) {
            var _this = this;
            this.track = track;
            // Scale the domain of the data
            this.xAxis.scale.domain(d3.extent(track.data, function (d) { return d.date; }));
            this.yAxis[0].scale.domain(d3.extent(track.data, dataseries.altitude.localValue));
            // Find max speed of everything on axis y1
            var speedSeries = this.series.filter(function (d) { return d.axis === 1; });
            var speedMax = d3.max(speedSeries, function (ser) { return d3.max(track.data, function (d) { return ser.localValue(d); }); });
            speedMax = Math.min(speedMax || 1, convert_1.default.speed.localValue(90)); // Hard limit 200mph
            this.yAxis[1].scale.domain([0, speedMax]);
            this.yAxis[2].scale.domain([0, 4]);
            // Update the x scale copy
            this.xScale0.domain(this.xAxis.scale.domain());
            this.trimmer = new trimmer_1.Trimmer(this.track);
            this.addLayer(this.trimLayer = new trim_1.TrimLayer(this.track, this.trimmer));
            this.addLayer(new flightmodes_1.FlightModes(this.track));
            this.addLayer(new series_1.SeriesLayer(this.track, this.series));
            this.addLayer(new flares_1.Flares(this.track));
            this.addLayer(new markers_1.Markers(this.track));
            // Listen for mouse movements
            this.layers.overlay
                .on("mouseout", function () { return _this.unfocus(); })
                .on("mousemove", function (evnt) { return _this.mousemove(evnt); })
                .on("mousedown", function (evnt) { return _this.mousedown(evnt); })
                .on("mouseup", function (evnt) { return _this.mouseup(evnt); })
                .on("touchstart", function (evnt) { return _this.mousedown(evnt); })
                .on("touchmove", function (evnt) { return _this.mousemove(evnt); })
                .on("touchend", function (evnt) { return _this.mouseup(evnt); })
                .on("touchcancel", function () { return _this.unfocus(); });
            // Listen for updates
            trackState.focusUpdates.subscribe(function (point) { return _this.focusLayer.drawFocus(point); });
            this.update();
        };
        TimeChart.prototype.unfocus = function () {
            trackState.focusUpdates.post(undefined);
            if (this.trimmer.dragging) {
                this.trimmer.dragging = false;
            }
        };
        TimeChart.prototype.mousemove = function (evnt) {
            if (this.trimmer.dragging) {
                // Update trim
                this.trimmer.active.max = this.mouseToUTC(evnt);
                this.trimLayer.update(this);
                trackState.focusUpdates.post(undefined);
            }
            else {
                // Find nearest data point to mouse
                var x0 = this.xAxis.scale.invert(d3.pointer(evnt)[0]);
                var index = this.bisectDate(this.track.data, x0);
                var d0 = this.track.data[index - 1];
                var d1 = this.track.data[index];
                var d = d0 !== undefined && d1 !== undefined && x0 - d0.date.getTime() > d1.date.getTime() - x0 ? d1 : d0;
                // Update focus
                trackState.focusUpdates.post(d, this.track);
            }
        };
        TimeChart.prototype.mousedown = function (evnt) {
            this.trimmer.dragging = true;
            this.trimmer.active.min = this.trimmer.active.max = this.mouseToUTC(evnt);
            this.trimLayer.update(this);
        };
        TimeChart.prototype.mouseup = function (evnt) {
            this.trimmer.dragging = false;
            this.trimmer.active.max = this.mouseToUTC(evnt);
            this.trimmer.saveTrim();
            this.trimLayer.update(this);
        };
        TimeChart.prototype.mouseToUTC = function (evnt) {
            return this.track.browserToUtc(this.xAxis.scale.invert(d3.pointer(evnt)[0]));
        };
        return TimeChart;
    }(basechart_1.BaseChart));
    exports.TimeChart = TimeChart;
    function init(trackId) {
        if (!document.getElementById("time-chart"))
            return;
        var timechart = new TimeChart("#time-chart", dataseries.timeSeries);
        // Get track data
        trackStore.getTrackData(trackId).then(function (result) { return timechart.loadTrack(result); });
    }
    exports.init = init;
});
//# sourceMappingURL=/assets/javascripts/charts/timechart.js.map;
